import { FormikValues, useFormikContext } from "formik";
import Button from "../../common/Button";

const BedStatusBottom = () => {
  const { resetForm, handleSubmit } = useFormikContext<FormikValues>();

  const resetBedStatus = () => {
    resetForm();
  }
  return (
    <div className="d-flex align-items-center justify-content-center mg-t-14">
      <Button type="button" onClick={resetBedStatus} className="mr-10">
        Revert
      </Button>
      <Button color="alert" type="submit">
        Update
      </Button>
    </div>
  );
};

export default BedStatusBottom;
